interface StackedLayoutProps {
  sidebar: React.ReactNode
  navbar: React.ReactNode
  children: React.ReactNode
}

export default function StackedLayout({
 sidebar, navbar, children 
}: StackedLayoutProps) {
  return (
    <div>
      {/* Static sidebar for desktop */}
      <div className="hidden lg:fixed lg:inset-y-0 lg:z-50 lg:flex lg:w-72 lg:flex-col h-full">
        {sidebar}
      </div>

      <div className="lg:pl-72">
        {/* Navbar */}
        {navbar}

        {/* Main content */}
        <main className="py-10">
          <div className="px-4 sm:px-6 lg:px-8">
            {children}
          </div>
        </main>
      </div>
    </div>
  )
} 